import { render, staticRenderFns } from "./InvoiceReviewModal.vue?vue&type=template&id=3f8d950a&"
import script from "./InvoiceReviewModal.vue?vue&type=script&lang=js&"
export * from "./InvoiceReviewModal.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceReviewModal.vue?vue&type=style&index=0&id=3f8d950a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports